import MainModel from "../../../components/Models/main-model";
import { brandPalette } from "../../../constants/brandPalette";
import {
  Box,
  FormLabel,
  Heading,
  Textarea,
  Button,
  VStack,
  HStack,
  Text,
} from "@chakra-ui/react";
import { useSelector, useDispatch } from "react-redux";
import { closeAdminHomeworkCommentModel } from "../../../modules/admin-modules/models/Actions";
import { useState, useEffect } from "react";
import { commentStuentHomeworkRequest } from "../../../modules/admin-modules/reports/Actions";
import { getAssistantsRequest } from "../../../modules/admin-modules/teachersAssistant/Actions";
import Select from "react-select";
import {
  adminModalBodyProps,
  adminModalContentProps,
  adminModalHeaderProps,
  adminSelectStyles,
} from "../../../components/Models/admin-modal-theme";
const HomeworkComment = ({ data, homeworkId }) => {
  const openHomeworkComment = useSelector((state) => state.model.isOpen27);
  const [comment, setComment] = useState("");
  const dispatch = useDispatch();
  const assistants = useSelector((state) => state.teacherassistants.assistants);
  const [assistant, setAssistant] = useState("");
  const [assistantComment, setAssistantComment] = useState("");
  const assistantsOptions = assistants?.data?.map((data) => {
    return { value: data.id, label: data.name, sign: data.school };
  });

  useEffect(() => {
    dispatch(getAssistantsRequest());
  }, []);

  const header = (
    <Box>
      <Heading textAlign="left" color={brandPalette.primary} fontSize="20px" fontWeight="900">
        Review submission
      </Heading>
      <Text mt={1} fontSize="sm" fontWeight="700" color="rgba(91, 13, 22, 0.55)">
        Add evaluation and assistant notes.
      </Text>
    </Box>
  );
  const handelAddComment = () => {
    dispatch(
      commentStuentHomeworkRequest({
        id: data?.id,
        body: {
          homework_id: homeworkId,
          student_id: data?.student?.id,
          evaluation: comment,
          assistant_id: assistant,
          assistant_comment: assistantComment,
        },
      })
    );
    dispatch(closeAdminHomeworkCommentModel());
  };
  const closeFunc = () => {
    dispatch(closeAdminHomeworkCommentModel());
    setComment("");
    setAssistant("");
    setAssistantComment("");
  };

  return (
    <MainModel
      isLoading={false}
      header={header}
      closeFunc={closeFunc}
      openVar={openHomeworkComment}
      buttonTitle={"Save changes"}
      buttonFunc={handelAddComment}
      cancelTitle="Cancel"
      contentProps={adminModalContentProps}
      headerProps={adminModalHeaderProps}
      bodyProps={adminModalBodyProps}
      footerProps={{
        borderTop: "1px solid rgba(214, 206, 192, 0.5)",
        py: 6,
      }}
    >
      <VStack align="stretch" spacing={5} dir="ltr">
        <HStack justify="space-between" flexWrap="wrap" spacing={3}>
          <Text fontSize="sm" fontWeight="800" color={brandPalette.primary}>
            Student: <Text as="span" fontWeight="900">{data?.student?.name || "N/A"}</Text>
          </Text>
          <Button
            as="a"
            href={`https://api.edutopiaonline.com/public/homework/${data?.file}`}
            target="_blank"
            size="sm"
            borderRadius="12px"
            bg="white"
            border="1px solid rgba(214, 206, 192, 0.85)"
            color={brandPalette.primary}
            fontWeight="800"
            _hover={{ bg: "rgba(255,255,255,0.75)" }}
          >
            Open file
          </Button>
        </HStack>

        <Box w="100%">
          <FormLabel fontWeight="800" color={brandPalette.primary}>
            Evaluation
          </FormLabel>
          <Textarea
            id="comment"
            bg="rgba(255,255,255,0.72)"
            borderColor="rgba(214, 206, 192, 0.85)"
            borderRadius="14px"
            placeholder="Write the evaluation…"
            onChange={(e) => setComment(e.target.value)}
            name="homework"
            _focus={{ borderColor: brandPalette.primary, boxShadow: "0 0 0 3px rgba(91, 13, 22, 0.12)" }}
          ></Textarea>
        </Box>

        <Box w="100%">
          <FormLabel fontWeight="800" color={brandPalette.primary}>
            Assistant
          </FormLabel>
          <Select
            styles={adminSelectStyles()}
            options={assistantsOptions}
            onChange={(e) => {
              setAssistant(e.value);
              document.getElementById("comment").value += "\n\n" + e.sign;
              setComment(document.getElementById("comment").value);
            }}
            placeholder="Select assistant"
          />
        </Box>

        <Box w="100%">
          <FormLabel fontWeight="800" color={brandPalette.primary}>
            Assistant notes
          </FormLabel>
          <Textarea
            id="assistantComment"
            bg="rgba(255,255,255,0.72)"
            borderColor="rgba(214, 206, 192, 0.85)"
            borderRadius="14px"
            placeholder="Write assistant notes…"
            onChange={(e) => setAssistantComment(e.target.value)}
            name="homework"
            _focus={{ borderColor: brandPalette.primary, boxShadow: "0 0 0 3px rgba(91, 13, 22, 0.12)" }}
          ></Textarea>
        </Box>
      </VStack>
    </MainModel>
  );
};

export default HomeworkComment;
